import { render, staticRenderFns } from "./mulazimmini.vue?vue&type=template&id=5a85538c&scoped=true"
import script from "./mulazimmini.vue?vue&type=script&lang=js"
export * from "./mulazimmini.vue?vue&type=script&lang=js"
import style0 from "./mulazimmini.vue?vue&type=style&index=0&id=5a85538c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a85538c",
  null
  
)

export default component.exports